import React, { useContext, useState } from "react";
import styles from "./ContactUs.module.css";
import HeadingComponent from "../../components/HeadingComponent/HeadingComponent";
import { LanguageContext } from "../../utills/LanguageContext";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  InputField,
  TextComponent,
  SubmitButton,
  Modal,
} from "../../components";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";

const languages = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

const ContactUs = () => {
  const { language } = useContext(LanguageContext);
  const { t } = useTranslation();

  const [queryTitle, setQueryTitle] = useState("");
  const [queryType, setQueryType] = useState("");
  const [queryMessage, setQueryMessage] = useState("");
  const [isModal, setIsModal] = useState(false)

  const options = languages.map((lang) => ({
    value: lang.code,
    label: lang.label,
  }));

  const selectedLang = options.find((opt) => opt.value === language);

  const handleSubmit = () => {
    if (!queryTitle || !queryType || !queryMessage) {
      alert("Please fill in all fields before submitting.");
      return;
    }

    console.log("📝 Contact Form Submitted:");
    console.log("Query Title:", queryTitle);
    console.log("Query Type:", queryType);
    console.log("Query Message:", queryMessage);

    setQueryTitle("");
    setQueryType("");
    setQueryMessage("");
    setIsModal(true)
    // alert("Your query has been submitted successfully!");
  };

  return (
    <div className={styles.AccountContent}>
      <HeaderComponent heading={"Contact Us"} headingStyle={styles.headingStyle} />

      <TextComponent
        className={styles.contactText}
        text="Feel free to contact us for any queries or complaints!"
        fontSize={18}
      />

      <InputField
        className={styles.inputNew}
        label={"Query"}
        placeholder={"Missing Quantity"}
        value={queryTitle}
        onChange={(e) => setQueryTitle(e.target.value)}
      />
      <Dropdown
        label={"Query Type"}
        value={queryType}
        style={{ color: "var(--black-color)" }}
        options={[
          { value: "Order Fulfillment Issue", id: 5 },
          { value: "Inventory / Stock Issue", id: 6 },
          { value: "Packaging Error", id: 7 },
        ]}
        onChange={(selected) => setQueryType(selected)}
      />
      <InputField
        className={styles.inputNew}
        placeholder={"Write Inquiry"}
        value={queryMessage}
        onChange={(e) => setQueryMessage(e.target.value)}
        textArea
        rows={6}
      />
      {/* <TextArea
        className={styles.TextAreaInput}
        placeholder={"Write Inquiry"}
        value={queryMessage}
        onChange={(e) => setQueryMessage(e.target.value)}
       
      /> */}

      <div className={styles.btnContainer}>
        <SubmitButton
          className={styles.SubmitBtn}
          title={"Submit"}
          primary
          onClick={handleSubmit}
          btnContainerClass={styles.Login_btnContainer}
          textClass={styles.Login_Text}
          btnClass={styles.Submit_btn}
        />
      </div>

      <Modal
        open={isModal}
        onCancel={() => { setIsModal(false) }}
        className={styles.modalCont}
        title={"Your query has been submitted successfully!"}
        headingClass={styles.modalHeading}
        width={"400px"}
        buttonTitle={"ok"}
        onBtnPress={() => setIsModal(false)}

      >

      </Modal>
    </div>
  );
};

export default ContactUs;
